import styled, { css } from 'styled-components';
import { CaretDown } from 'styled-icons/boxicons-regular/CaretDown';
import { ChevronUp } from 'styled-icons/boxicons-regular/ChevronUp';
import { CircleUp } from 'styled-icons/icomoon/CircleUp';
import { SortingDirectionsType } from '~src/types';
import { media } from '~constants/media';

export const Block = styled.div`
  background-color: white;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: white;

  thead,
  tbody,
  tfoot {
    vertical-align: middle;
  }

  td,
  th,
  tr {
    vertical-align: inherit;
  }
`;

export const Tr = styled.tr<{
  hasBottomBorder?: boolean;
  isCollapsible?: boolean;
  bgColor?: string;
}>`
  ${({ hasBottomBorder = true, bgColor, isCollapsible }) => css`
    background-color: ${bgColor || 'initial'};

    border-bottom: ${hasBottomBorder && `2px solid rgb(231, 231, 231)`};

    &:hover {
      background-color: ${!bgColor && isCollapsible && '#f4f8f9'};
      cursor: ${isCollapsible && 'pointer'};
    }
  `}
`;

export const Th = styled.th`
  color: #706f6f;
  text-align: left;
  white-space: nowrap;
`;

export const Text = styled.span<{ isCursorPointer?: boolean }>`
  ${({ isCursorPointer }) => isCursorPointer && `cursor: pointer;`}
`;

export const Td = styled.td<{ isContentCentered?: boolean }>`
  position: relative;

  ${({ isContentCentered }) => css`
    ${isContentCentered &&
      `
        text-align: center;
      `}
  `}
`;

export const OpenerText = styled.span`
  color: #0071bb;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const SortingIcon = styled(CaretDown)<{
  direction: SortingDirectionsType;
}>`
  display: inline-block;
  width: 10px;
  height: 10px;
  transition: transform 0.25s;
  cursor: pointer;

  ${media.md`
    width: 13px;
    height: 13px;
    margin-left: 5px;
  `}
  ${({ direction }) => {
    return css`
      transform: ${direction === 'desc' && 'rotate(180deg)'};
    `;
  }}
`;

export const ShowMoreButton = styled.button`
  padding: 15px 30px;
  background-color: #6082ff;
  border-radius: 50px;
  font-size: 16px;
  line-height: 18px;
  text-align: center;
  color: white;
  outline: none;
  border: none;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;

export const ShowMoreButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 26px;

  ${media.xl`
    margin-top: 54px;
  `}
`;

const toggleIconCSS = css<{
  isCollapsed: boolean;
  expandAnimationDuration: number;
}>`
  width: 15px;

  ${media.md`
    width: 24px;
  `}

  ${({ isCollapsed, expandAnimationDuration }) => css`
    transform: ${!isCollapsed && `rotate(180deg)`};
    transition: transform ${expandAnimationDuration}ms;
  `}
`;

export const CircleUpIcon = styled(CircleUp)`
  ${toggleIconCSS};
  color: #0f79bf;
`;

export const ChevronUpIcon = styled(ChevronUp)`
  ${toggleIconCSS};
  color: #a3b1d6;
`;
